import { ApiClient } from "@/utils/apiClient";
import type { ApiResponse } from "@/models/api";
import type { Client } from "@/models/client";

export type ClientGetResponse = ApiResponse<{
  client: Client;
}>;

export abstract class ClientApiService {
  // NOTE We can only operate on currently selected client, based on domain
  public static async get(): Promise<ClientGetResponse> {
    const response = await ApiClient.getClient().get<ClientGetResponse>('');
    return response.data;
  }
}